import * as Schema from "effect/Schema";
import { TrimmedString } from "./baseSchemas.ts";
const unicodeControlPattern = /\p{Cc}/u;
const invalidUnicodeScalarPattern = /[\uD800-\uDFFF]/u;
const whitespacePattern = /\s/u;

const sshTargetBoundary = Schema.makeFilter<string>(
  (value) => {
    const byteLength = new TextEncoder().encode(value).byteLength;
    if (byteLength < 1 || byteLength > 512) {
      return "A System SSH Target must contain 1 to 512 UTF-8 bytes.";
    }
    if (whitespacePattern.test(value) || unicodeControlPattern.test(value)) {
      return "A System SSH Target cannot contain whitespace or control characters.";
    }
    if (invalidUnicodeScalarPattern.test(value)) {
      return "A System SSH Target must contain only Unicode scalar values.";
    }
    if (value.startsWith("-")) {
      return "A System SSH Target cannot be parsed as an OpenSSH option.";
    }
    const at = value.indexOf("@");
    if (at !== -1 && (at === 0 || at === value.length - 1 || at !== value.lastIndexOf("@"))) {
      return "A System SSH Target must be one alias or one user@host token.";
    }
    return true;
  },
  { identifier: "SystemSshTargetBoundary" },
);

/** One exact OpenSSH destination token after trimming. */
export const SystemSshTarget = TrimmedString.check(sshTargetBoundary).pipe(
  Schema.brand("SystemSshTarget"),
);
export type SystemSshTarget = typeof SystemSshTarget.Type;
